import { AppDispatch } from '../store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '../config';
import { prepareHeaders } from './helpers';
import { SERVICE_API_TAG_TYPES } from '../constants';
import { createBaseQueryWithReauth } from './baseQueryWithReauth';

const baseApi = createApi({
  reducerPath: 'baseApi',
  keepUnusedDataFor: config.rtkCacheTimeout,
  baseQuery: createBaseQueryWithReauth(
    fetchBaseQuery({ baseUrl: config.assetServiceBaseUrl, prepareHeaders: prepareHeaders }),
  ),
  tagTypes: SERVICE_API_TAG_TYPES,
  endpoints: () => ({}),
});

interface BaseApiCustomHelpers {
  invalidateAllTags: () => (dispatch: AppDispatch) => ReturnType<typeof baseApi.util.invalidateTags>;
}

type BaseApiWithCustom = typeof baseApi & { custom: BaseApiCustomHelpers };

const baseApiWithCustom = baseApi as BaseApiWithCustom;

baseApiWithCustom.custom = {
  invalidateAllTags: () => (dispatch: AppDispatch) =>
    dispatch(baseApi.util.invalidateTags(SERVICE_API_TAG_TYPES as any)),
};

export { baseApiWithCustom as baseApi };
export const resetApiState = baseApi.util.resetApiState;
